import { ReactComponent as NodeLogo } from "../../../../src/languages/nodejs.svg";
import * as React from 'react';
export default {
  NodeLogo,
  React
};